import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import {
  Grid,
  Card,
  IconButton,
  Icon
} from '@material-ui/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Navigation } from 'swiper';
import { makeStyles } from '@material-ui/core/styles';
import MarketingImage from 'components/Pages/marketing-img.svg';
import 'swiper/css/bundle';
import './swiperStyles.css';


const useStyles = makeStyles({
  slider: {
    padding: '0px 27px',
    borderRadius: 6,
    height: '100%',
    maxHeight: 250,
    width: '100%',
  },
  slide: {
    minWidth: '275px !important'
  },
  tabBorder: {
    border: '1px solid #103A99'
  }
});

const HelpTabs = () => {
  const history = useHistory();
  const { helpSubCategories } = useSelector((state: IReduxState) => state.help);
  const { categoryUrl, subCategoryUrl} = useParams<{ categoryUrl?: string; subCategoryUrl?: string}>();
  const classes = useStyles();

  return (
    <div className="flex-column items-center justify-center">
      <Grid xs={12} sm={10} md={10}>
        {helpSubCategories.length ?
          <Swiper
            pagination={{
              clickable: true,
            }}
            modules={[FreeMode, Pagination, Navigation]}
            watchSlidesProgress={Boolean(true)}
            slidesPerView={3}
            navigation={Boolean(true)}
            slidesPerGroup={3}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              640: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              1615: {
                slidesPerView: 3,
                spaceBetween: 10,
              }
            }}
            className={`${classes.slider} mySwiper`}
          >
            {helpSubCategories.map((item) => (
              <SwiperSlide key={item.title} className={classes.slide}>
                <Card
                  elevation={3}
                  className={`${item.path === subCategoryUrl ? classes.tabBorder : ''} p-12 flex-column justify-center items-center m-5`}
                  onClick={() => history.push(`/help/${categoryUrl}/${item.path}`)}
                >
                  <div className="flex">
                    <IconButton
                      size="small"
                      className="p-2 bg-light-gray"
                    >
                      <Icon
                        color={item.path === subCategoryUrl ? 'primary' : 'inherit'}
                        className="text-36"
                      >
                        {item.icon}
                      </Icon>
                    </IconButton>
                  </div>
                  <div className="flex-column justify-center items-center">
                    <p className="m-0 h5 text-light-gray font-medium">{item.title}</p>
                  </div>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
          :
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            className="mt-20"
          >
            <div className="flex-grow flex-column relative scroll-y justify-center items-center">
              <img src={MarketingImage} alt="under reconstruction" width="258" />
            </div>
            <h2 className="font-bold py-6 text-center text-deep-gray">Coming Soon</h2>
          </Grid>
        }
      </Grid>
    </div>
  );
};

export default HelpTabs;
